
import React from 'react'
import { useState, useEffect, useRef } from "react";
import $ from 'jquery';

// Material Dashboard 2 PRO React components
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";


// import react icons
import { useNavigate, useLocation } from "react-router-dom";

// Imports React bootstrap
import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';

// File Imports
import ComboBox from "Features/ComboBox";
import { globalQuery, resetGlobalQuery } from "assets/Constants/config-constant";
import ErrorModal from "components/Modals/ErrorModal";
import SuccessModal from "components/Modals/SuccessModal";
import FrmMProductCategory3Entry from 'Masters/MProductCategory3/FrmMProductCategory3Entry';
import FrmMProductTypeEntry from 'Masters/MProductType/FrmProductEntry';
import FrmMProductCategory1Entry from 'Masters/MProductCategory1/FrmProductCategory1Entry';
import FrmMProductCategory2Entry from 'Masters/MProductCategory2/FrmMProductCategory2Entry';
import ConfigConstants from "assets/Constants/config-constant";
import FrmValidations from 'FrmGeneric/FrmValidations';

export default function FrmMProductCategory4Entry(props) {

  const { state } = useLocation();
  const { productcategory4ID = 0, keyForViewUpdate = 'Add', compType = 'Masters' } = state || {};

  const configConstants = ConfigConstants();
  const { COMPANY_ID, UserName } = configConstants;


  // use refs
  const comboDataAPiCall = useRef();
  const validate = useRef();

  // combobox Option
  const [cat4Category3Options, setCat4Category3Options] = useState([])
  const [cat4Category2Options, setCat4Category2Options] = useState([])
  const [cat4ProductTypeOptions, setCat4ProductTypeOptions] = useState([]);
  const [cat4ProductCategory1Options, setCat4ProductCategory1Options] = useState([])

  // Add Product Type Form Fields
  const [cmb_cat4_product_category2_id, setCat4ProductCategory2Id] = useState('');
  const [cmb_cat4_product_category1_id, setCat4ProductCategory1Id] = useState('');
  const [cmb_cat4_product_type_id, setCat4ProductTypeId] = useState('');
  const [txt_cat4_product_category4_name, setCat4ProductCategory4Name] = useState('');
  const [txt_cat4_product_category4_short_name, setCat4ProductCategory4ShortName] = useState('');
  const [txt_cat4_remark, setCat4Remark] = useState('');
  const [cmb_cat4_product_category3_id, setCat4PCategory3Id] = useState('');
  const [actionType, setActionType] = useState('')


  // Error Msg HANDLING
  const handleCloseErrModal = () => setShowErrorMsgModal(false);
  const [showErrorMsgModal, setShowErrorMsgModal] = useState(false);
  const [errMsg, setErrMsg] = useState('');

  // For navigate
  const navigate = useNavigate();

  // Success Msg HANDLING
  const handleCloseSuccessModal = () => {
    setShowSuccessMsgModal(false);
    if (sessionStorage.getItem('dataAddedByCombo') !== 'dataAddedByCombo') {
      navigate(`/Masters/ProductCategory4Listing`);
    }
  }
  const [showSuccessMsgModal, setShowSuccessMsgModal] = useState(false);
  const [succMsg, setSuccMsg] = useState('');

  // Add rec modal
  const closeCat4RecModal = async () => {
    switch (cat4ModalHeaderName) {
      case 'Product Type':
        comboDataAPiCall.current.fillMasterData("smv_product_type", "", "").then((productTypes) => {
          setCat4ProductTypeOptions(productTypes)
        })
        break;
      case 'Product Category-1':
        var proctTypeIdVal = document.getElementById('cmb_cat4_product_type_id').value;

        comboDataAPiCall.current.fillMasterData("smv_product_category1", "product_type_id", proctTypeIdVal).then((productCategory1) => {
          setCat4ProductCategory1Options(productCategory1);
        })
        break;
      case 'Product Category-2':
        var productCat1Val = document.getElementById('cmb_cat4_product_category1_id').value;
        comboDataAPiCall.current.fillMasterData("smv_product_category2", "product_category1_id", productCat1Val).then((productCategory2) => {
          setCat4Category2Options(productCategory2)
        })

        break;
      case 'Product Category-3':
        var productCat2Val = document.getElementById('cmb_cat4_product_category2_id').value;

        comboDataAPiCall.current.fillMasterData("smv_product_category3", "product_category2_id", productCat2Val).then((productCategory3) => {
          setCat4Category3Options(productCategory3)
        })
        break;
      default:
        break;
    }
    setShowAddRecCat4Modal(false);
    sessionStorage.removeItem('dataAddedByCombo')
    setTimeout(() => {
      $(".erp_top_Form").css({
        "padding-top": "110px"
      });
    }, 200)

  }
  const [showAddRecCat4Modal, setShowAddRecCat4Modal] = useState(false);
  const [cat4ModalHeaderName, setCat4ModalHeaderName] = useState('')

  useEffect(async () => {
    await ActionType();
    fillComobos();
    if (productcategory4ID !== 0) {
      await FnCheckUpdateResponce();
    }
  }, [])

  const ActionType = async () => {
    switch (keyForViewUpdate) {
      case 'update':
        setActionType('(Modify)');
        break;
      case 'view':
        setActionType('(View)');
        $("input[type=radio]").attr('disabled', true);
        break;
      default:
        setActionType('(Create)');
        break;
    }

  };

  const fillComobos = () => {
    comboDataAPiCall.current.fillMasterData("smv_product_type", "", "").then((productTypes) => {
      setCat4ProductTypeOptions(productTypes)
    })
  }

  const FnCheckUpdateResponce = async () => {
    try {
        const apiCall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productcategory4/FnShowParticularRecordForUpdate/${productcategory4ID}`)
        const updateRes = await apiCall.json();

        let resp = JSON.parse(updateRes.data)
        setCat4ProductTypeId(resp.product_type_id);
        await comboOnChange('productType')
        setCat4ProductCategory1Id(resp.product_category1_id);
        await comboOnChange('productCategory1')
        setCat4ProductCategory2Id(resp.product_category2_id);
        await comboOnChange('productCategory2')
        setCat4PCategory3Id(resp.product_category3_id)
        setCat4ProductCategory4Name(resp.product_category4_name);
        setCat4ProductCategory4ShortName(resp.product_category4_short_name);
        setCat4Remark(resp.remark);

        switch (resp.is_active) {
          case true:
            document.querySelector('input[name="isactive"][value="1"]').checked = true;
            break;
          case false:
            document.querySelector('input[name="isactive"][value="0"]').checked = true;
            break;
        }
        // var keyForViewUpdate = sessionStorage.getItem('keyForViewUpdate');

        switch (keyForViewUpdate) {
          case 'view':
            $("input[type=radio]").attr('disabled', true);
            $('#saveBtn').attr('disabled', true);
            await validate.current.readOnly("productcategory4FormId");
            break;
          case 'update':
            $('#cmb_cat4_product_type_id').attr('disabled', true);
            $('#cmb_cat4_product_category1_id').attr('disabled', true);
            $('#cmb_cat4_product_category2_id').attr('disabled', true);
            $('#cmb_cat4_product_category3_id').attr('disabled', true);
            $('#txt_cat4_product_category4_name').attr('disabled', true);
            $('#txt_cat4_product_category4_short_name').attr('disabled', true);
            break;
        }


    } catch (error) {
      console.log("error", error)
      navigate('/Error')
    }
  }

  const FnAddUpdateCategory4 = async () => {
    try {
      const checkIsValidate = await validate.current.validateForm('productcategory4FormId');
      if (checkIsValidate) {
        if (productcategory4ID === '' || productcategory4ID === null) { productcategory4ID = 0 }
        var active;
        var activeValue = document.querySelector('input[name=isactive]:checked').value

        switch (activeValue) {
          case '1': active = true; break;
          case '0': active = false; break;

        }

        const data = {
          company_id: COMPANY_ID,
          product_category4_id: productcategory4ID,
          created_by: UserName,
          modified_by: productcategory4ID === 0 ? null : UserName,
          product_category1_id: cmb_cat4_product_category1_id,
          product_category2_id: cmb_cat4_product_category2_id,
          product_category3_id: cmb_cat4_product_category3_id,
          product_type_id: cmb_cat4_product_type_id,
          product_category4_name: txt_cat4_product_category4_name,
          product_category4_short_name: txt_cat4_product_category4_short_name.trim(),
          remark: txt_cat4_remark,
          is_active: active,

        };
        console.log(data);
        const requestOptions = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(data)
        };
        const apicall = await fetch(`${process.env.REACT_APP_BASE_URL}/api/productcategory4/FnAddUpdateRecord`, requestOptions)
        const responce = await apicall.json()
        console.log("response error: ", responce);
        if (responce.error !== "") {
          console.log("response error: ", responce.error);
          setErrMsg(responce.error)
          setShowErrorMsgModal(true)

        } else {
          var data1 = JSON.parse(responce.data)
          console.log("productcategory4ID", data1);
          const evitCache = comboDataAPiCall.current.evitCache();
          console.log(evitCache);
          setSuccMsg(responce.message)
          setShowSuccessMsgModal(true);


        }

      }
    } catch (error) {
      console.log("error: ", error)
      navigate('/Error')
    }

  };

  const comboOnChange = async (key) => {
    switch (key) {
      case 'productType':
        var productTpVal = document.getElementById('cmb_cat4_product_type_id').value;
        setCat4ProductTypeId(productTpVal)
        if (productTpVal === '0') {
          setCat4ModalHeaderName('Product Type')
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setShowAddRecCat4Modal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
            // document.querySelectorAll(".erp_top_Form")[0].style.paddingTop = "0px";
          }, 200)
        } else {
          $('#error_cmb_cat4_product_type_id').hide();
          resetGlobalQuery();
          globalQuery.columns.push("field_id");
          globalQuery.columns.push("field_name");
          globalQuery.table = "smv_product_category1"
          globalQuery.conditions.push({ field: "product_type_id", operator: "=", value: productTpVal });
          globalQuery.conditions.push({ field: "is_delete", operator: "=", value: 0 });
          globalQuery.conditions.push({ field: "company_id", operator: "=", value: COMPANY_ID });
          const productCategory1ApiCall = await comboDataAPiCall.current.removeCatcheFillCombo(globalQuery);
          setCat4ProductCategory1Options(productCategory1ApiCall);
          setCat4ProductCategory1Id('');
          setCat4ProductCategory2Id('');
          setCat4PCategory3Id('');

        }
        break;

      case 'productCategory1':
        var productCat1Val = document.getElementById('cmb_cat4_product_category1_id').value;
        var proctTypeIdVal = document.getElementById('cmb_cat4_product_type_id').value;
        if (productCat1Val === '0') {
          setCat4ProductCategory1Id(productCat1Val)
          setCat4ModalHeaderName('Product Category-1')
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setShowAddRecCat4Modal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 200)
        } else {
          setCat4ProductCategory1Id(productCat1Val)
          $('#error_cmb_cat4_product_category1_id').hide();

          resetGlobalQuery();
          globalQuery.columns.push("field_id");
          globalQuery.columns.push("field_name");
          globalQuery.table = "smv_product_category2"
          globalQuery.conditions.push({ field: "company_id", operator: "=", value: COMPANY_ID });
          globalQuery.conditions.push({ field: "product_type_id", operator: "=", value: proctTypeIdVal });
          globalQuery.conditions.push({ field: "product_category1_id", operator: "=", value: productCat1Val });
          globalQuery.conditions.push({ field: "is_delete", operator: "=", value: 0 });
          var productCat2ApiCall = await comboDataAPiCall.current.fillFiltersCombo(globalQuery)
          setCat4Category2Options(productCat2ApiCall)
          setCat4ProductCategory2Id('');
          setCat4PCategory3Id('');
        }
        break;

      case 'productCategory2':
        var productCat2Val = document.getElementById('cmb_cat4_product_category2_id').value;
        var productCat1Val = document.getElementById('cmb_cat4_product_category1_id').value;
        var productTpVal = document.getElementById('cmb_cat4_product_type_id').value;
        if (productCat2Val === '0') {
          setCat4ProductCategory2Id(productCat2Val)
          setCat4ModalHeaderName('Product Category-2')
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setShowAddRecCat4Modal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 200)
        } else {
          $('#error_cmb_cat4_product_category2_id').hide();
          setCat4ProductCategory2Id(productCat2Val)
          // Product category 3 list
          resetGlobalQuery();
          globalQuery.columns.push("field_id");
          globalQuery.columns.push("field_name");
          globalQuery.table = "smv_product_category3"
          globalQuery.conditions.push({ field: "company_id", operator: "=", value: COMPANY_ID });
          globalQuery.conditions.push({ field: "product_type_id", operator: "=", value: productTpVal });
          globalQuery.conditions.push({ field: "product_category1_id", operator: "=", value: productCat1Val });
          globalQuery.conditions.push({ field: "product_category2_id", operator: "=", value: productCat2Val });
          globalQuery.conditions.push({ field: "is_delete", operator: "=", value: 0 });
          var productCat3ApiCall = await comboDataAPiCall.current.fillFiltersCombo(globalQuery)
          setCat4Category3Options(productCat3ApiCall)
          setCat4PCategory3Id('');
        }
        break;
      case 'productCategory3':
        var productCat3Val = document.getElementById('cmb_cat4_product_category3_id').value;
        if (productCat3Val === '0') {
          setCat4PCategory3Id(productCat3Val)
          setCat4ModalHeaderName('Product Category-3')
          sessionStorage.setItem('dataAddedByCombo', 'dataAddedByCombo')
          setShowAddRecCat4Modal(true)
          setTimeout(() => {
            $(".erp_top_Form").eq(1).css("padding-top", "0px");
          }, 200)
        } else {
          setCat4PCategory3Id(productCat3Val)
        }

        break;
    }
  }

  const cat4DisplayRecordComponent = () => {
    switch (cat4ModalHeaderName) {
      case 'Product Type':
        return <FrmMProductTypeEntry btn_disabled />;
      case 'Product Category-1':
        return <FrmMProductCategory1Entry btn_disabled />;
      case 'Product Category-2':
        return <FrmMProductCategory2Entry btn_disabled />
      case 'Product Category-3':
        return <FrmMProductCategory3Entry btn_disabled />
      default:
        return null;
    }
  }


  const validateFields = () => {
    validate.current.validateFieldsOnChange('productcategory4FormId')
  }

  return (
    <>
      <div className='erp_top_Form'>
        <ComboBox ref={comboDataAPiCall} />
        <FrmValidations ref={validate} />

        <div className='card p-1'>
          <div className='card-header text-center py-0'>
            <label className='erp-form-label-lg main_heding'>Product Category-4 {actionType}  </label>
          </div>

          <form id="productcategory4FormId">
            <div className="row erp_transporter_div">
              <div className="col-sm-6 erp_form_col_div">
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Type<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_cat4_product_type_id" className="form-select form-select-sm" value={cmb_cat4_product_type_id} onChange={() => { comboOnChange('productType'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0" disabled={props.btn_disabled}>Add New Record+</option>
                      {cat4ProductTypeOptions?.map(productType => (
                        <option value={productType.field_id}>{productType.field_name}</option>
                      ))}
                    </select>
                    <MDTypography variant="button" id="error_cmb_cat4_product_type_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Category1<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_cat4_product_category1_id" className="form-select form-select-sm" value={cmb_cat4_product_category1_id} onChange={() => { comboOnChange('productCategory1'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0" disabled={props.btn_disabled}>Add New Record+</option>
                      {cat4ProductCategory1Options?.map(productCategory1 => (
                        <option value={productCategory1.field_id}>{productCategory1.field_name}</option>
                      ))}
                    </select>
                    <MDTypography variant="button" id="error_cmb_cat4_product_category1_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Category2<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_cat4_product_category2_id" className="form-select form-select-sm" value={cmb_cat4_product_category2_id} onChange={() => { comboOnChange('productCategory2'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0" disabled={props.btn_disabled}>Add New Record+</option>
                      {cat4Category2Options?.map(productCategory2 => (
                        <option value={productCategory2.field_id}>{productCategory2.field_name}</option>
                      ))}
                    </select>
                    <MDTypography variant="button" id="error_cmb_cat4_product_category2_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                {/* new combox category3 */}
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Product Category3<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <select id="cmb_cat4_product_category3_id" className="form-select form-select-sm" value={cmb_cat4_product_category3_id} onChange={() => { comboOnChange('productCategory3'); validateFields(); }}>
                      <option value="">Select</option>
                      <option value="0" disabled={props.btn_disabled}>Add New Record+</option>
                      {cat4Category3Options?.map(productCategory3 => (
                        <option value={productCategory3.field_id}>{productCategory3.field_name}</option>

                      ))}

                    </select>
                    <MDTypography variant="button" id="error_cmb_cat4_product_category3_id" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>
              </div>

              {/* second row */}

              <div className="col-sm-6 erp_form_col_div">
                <div className='row'>
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Category 4 Name<span className="required">*</span></Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_cat4_product_category4_name" className="erp_input_field" value={txt_cat4_product_category4_name} onChange={e => { setCat4ProductCategory4Name(e.target.value); validateFields(); }} maxLength="255" />
                    <MDTypography variant="button" id="error_txt_cat4_product_category4_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label">Short Name</Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control type="text" id="txt_cat4_product_category4_short_name" className="erp_input_field" value={txt_cat4_product_category4_short_name} onChange={e => { setCat4ProductCategory4ShortName(e.target.value.toUpperCase()); validateFields(); }} maxLength="4" optional="optional" />
                    <MDTypography variant="button" id="error_txt_cat4_product_category4_short_name" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>

                </div>

                <div className="row">
                  <div className='col-sm-3'>
                    <Form.Label className="erp-form-label"> Remark </Form.Label>
                  </div>
                  <div className='col'>
                    <Form.Control as="textarea" rows={1} className="erp_txt_area" id="txt_cat4_remark" value={txt_cat4_remark} onChange={e => { setCat4Remark(e.target.value); validateFields(); }} maxLength="255" optional="optional" />
                    <MDTypography variant="button" id="error_txt_cat4_remark" className="erp_validation" fontWeight="regular" color="error" style={{ display: "none" }}>
                    </MDTypography>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-3">
                    <Form.Label className="erp-form-label">Is Active</Form.Label>
                  </div>
                  <div className="col">
                    <div className="erp_form_radio">
                      <div className="fCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="Yes"
                          type="radio"
                          value="1"
                          name="isactive"
                          defaultChecked
                        />
                      </div>
                      <div className="sCheck">
                        <Form.Check
                          className="erp_radio_button"
                          label="No"
                          value="0"
                          type="radio"
                          name="isactive"
                        />
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>

          </form>
          <div className="card-footer py-0 text-center">
            <MDButton type="button" className="erp-gb-button"
              onClick={() => {
                const path = compType === 'Register' ? '/Masters/ProductCategory4Listing/reg' : '/Masters/ProductCategory4Listing';
                navigate(path);
              }}
              variant="button"
              fontWeight="regular" disabled={props.btn_disabled ? true : false}
            >Back</MDButton>
            {keyForViewUpdate !== 'view' ? (
              <MDButton type="submit" onClick={FnAddUpdateCategory4} id="saveBtn" className="erp-gb-button erp_MLeft_btn " variant="button"
                fontWeight="regular">save</MDButton>
            ) : null}
          </div >
        </div>
        <SuccessModal handleCloseSuccessModal={() => handleCloseSuccessModal()} show={[showSuccessMsgModal, succMsg]} />
        <ErrorModal handleCloseErrModal={() => handleCloseErrModal()} show={[showErrorMsgModal, errMsg]} />


        {/* Add new Record Popup */}
        {/* //changes by tushar */}
        <Modal size="lg" show={showAddRecCat4Modal} onHide={closeCat4RecModal} backdrop="static" keyboard={false} centered >

          <Modal.Body className='erp_city_modal_body'>
            <div className='row'>
              <div className='col-12 align-self-end'><button type="button" className="erp-modal-close btn-close" aria-label="Close" onClick={closeCat4RecModal}></button></div>
            </div>
            {cat4DisplayRecordComponent()}
          </Modal.Body>
        </Modal >

      </div >

    </>
  )
}
